import { HttpResponse } from '@angular/common/http';
import { Quiz } from './quiz';
import { QuizDto } from './quiz.dto';

export class PaginatedDto {
    readonly payload: Quiz[];
    readonly total: number;

    constructor(response: HttpResponse<QuizDto[]>) {
        this.payload = (response.body ?? []).map((dto) => new Quiz(dto));
        this.total = parseInt(response.headers.get('X-Total-Count') ?? '0', 10);
    }
}
